@if (title) {
<h6 class="s1 col-1">{{ title }}</h6>
}

@for (item of items; track $index; let first = $first) {
<href class="flex flex-middle"
      [class.m-t-4]="!first || title"
      [link]="item.link || ''">
    @if (item.image) {
    <img class="_image flex-noshrink m-r-3"
         [ratio]="1"
         [width]="52"
         [dfImage]="item.image"
         [attr.alt]="item.label">
    }
    <p class="p2 flex-grow"
       *iCms="'label' of item; content 'html'"></p>
</href>
}
